// extracted by mini-css-extract-plugin
module.exports = {"wave":"Wave_wave__feeJT","path":"Wave_path__J3SuJ","pulse":"Wave_pulse__HVwY5"};